import { AssetPlan } from "../models/asset";

export const AssetPlanDto = (data: any): AssetPlan => {
    return {
        id: data.productId,
        name: data.productName,
    };
}